module.exports = __webpack_public_path__ + "img/jxz.1f7dae75.svg";